import type { ReactElement } from 'react';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';

interface Props {
  label: string;
  enabled: boolean;
  children: ReactElement;
}

/** Shows the item label next to an icon-only side navigation entry (collapsed sidebar). */
export function SideNavTooltip({ label, enabled, children }: Props) {
  if (!enabled) return children;

  return (
    <Tooltip>
      <TooltipTrigger asChild>{children}</TooltipTrigger>
      <TooltipContent side="right" sideOffset={8}>{label}</TooltipContent>
    </Tooltip>
  );
}
